import React from "react";
import { CallToAction } from "./";
import styled from "styled-components";
import tw from "tailwind.macro";

const CardContainer = styled.div`
  ${tw`flex relative justify-center bg-white mx-4`}
  height: 98%;
  padding: 0.8125rem;
`;

const Paragraph = styled.div`
  ${tw`font-franklin text-mattamy-gray font-thin overflow-y-hidden`}
  font-size: 0.6875rem;
`;

const BlueBar = styled.span`
  ${tw`w-10/12 mx-auto bg-mattamy-blue h-3 absolute inset-x-0 bottom-0`}
  height: 0.625rem;
  margin-bottom: -0.3125rem;
`;

const Card = ({ card = {} }) => {
  return (
    <CardContainer id={`card_${card.id}`}>
      <div className="inner">
        <div className="relative pb-2/3">
          <img
            className="absolute h-full w-full object-cover"
            src={card.imageUrl}
            alt={card.imageAlt}
          />
        </div>
        <div className="flex flex-col pl-3 pr-1 text-mattamy-gray">
          <div className="pt-4">
            <h4
              className="font-normal text-xl truncate uppercase
                font-trade-gothic-20 leading-snug mt-1"
            >
              {card.title}
            </h4>
          </div>

          <div className="-mt-2">
            <span className="leading-none font-franklin text-sm">
              {card.subtitle}
            </span>
          </div>

          <div className="paragraph mt-3 flex-grow overflow-y-hidden">
            <Paragraph>{card.paragraph}</Paragraph>
          </div>

          <div className="mt-2" />

          <div className="mt-3 mb-5 w-full flex flex-col items-center">
            {card.ctas &&
              card.ctas.map((cta, i) => (
                <div className="-mb-2" key={`${cta.name}-${i}`}>
                  <CallToAction {...cta} />
                </div>
              ))}
          </div>
        </div>

        <BlueBar />
      </div>
    </CardContainer>
  );
};

export default Card;
